/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const ArrowRight = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M13.3215 20L20.1144 13.2328C20.4543 12.8941 21.3731 12.0039 21.3731 12.0039C21.3731 12.0039 20.4579 11.1094 20.1144 10.7672L13.3215 4L12.2608 5.05665L18.4805 11.2528L2.62695 11.2528L2.62695 12.7472H18.4805L12.2608 18.9433L13.3215 20Z"
                        fill={color}
                    />
                </svg>
        );
    };
